import { render } from "./ProjectAddView.vue?vue&type=template&id=dd3b5c96"
import script from "./ProjectAddView.vue?vue&type=script&lang=js"
export * from "./ProjectAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__